/** Per-link switch for "None of these work? Suggest a time" on the candidate's booking page. */
export function TimeSuggestionsToggle({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
}) {
  return (
    <label className="mt-4 flex items-start gap-2 text-sm text-gray-800">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-gray-300"
      />
      <span>
        Let candidates suggest their own time
        <span className="mt-0.5 block text-xs text-gray-500">
          Adds “None of these work? Suggest a time” under the free times. They can name any day and time
          range, free or not. You get an email and a card on the Log; nothing is booked until you agree
          a time with them.
        </span>
      </span>
    </label>
  );
}
